import { injectable } from 'inversify';

import {
  DtoBase,
  Enums,
  SharedModels,
  TenantModels,
  UIDtoFactory,
  UserModels,
} from '@project44-models/iam-gateway';

import { ResourceIdentifierModel } from '../../../../shared/abstract/domain/ResourceIdentifierModel';

@injectable()
export class UnifiedRolesAdapter {
  public toUnifiedRoleCollectionDto(
    unifiedRoleCollection: SharedModels.UnifiedRoleCollectionViewModel,
  ): DtoBase<SharedModels.UnifiedRoleCollectionViewModel> {
    return UIDtoFactory.create(
      Enums.UiDtoFactoryEnum.UNIFIED_ROLE_COLLECTION,
      unifiedRoleCollection,
    );
  }

  toUserWithTenantContextUnifiedRolesIdentifier(
    userDto: DtoBase<UserModels.UserViewModel>,
    tenantDto: DtoBase<TenantModels.TenantViewModel>,
  ): DtoBase<ResourceIdentifierModel> {
    return new DtoBase<ResourceIdentifierModel>({
      model: {
        resourceIdentifier: userDto.source.getLakeId(),
        queryParams: new URLSearchParams([
          [`tenantUuid`, tenantDto.source.getTenantUuid()],
        ]),
      },
    });
  }
}
